export default __webpack_public_path__ + "static/media/vectuel_logo_white.498f7867.png";